export default __webpack_public_path__ + "static/media/balloon.a8e83f08.ico";